import React from 'react';
import { TrendingUp } from 'lucide-react';

const StatCard = ({
    title,
    value,
    icon: Icon,
    iconBgColor = 'bg-blue-100',
    iconColor = 'text-blue-500',
    trend = null,
    trendUp = true
}) => {
    return (
        <div className="bg-white p-4 rounded-lg shadow-sm">
            <div className="flex items-center justify-between mb-3">
                <h3 className="text-gray-500">{title}</h3>
                <div className={`w-10 h-10 ${iconBgColor} rounded-full flex items-center justify-center`}>
                    <Icon className={`w-5 h-5 ${iconColor}`} />
                </div>
            </div>
            <p className="text-2xl font-bold">{value}</p>

            {trend && (
                <div className={`flex items-center mt-2 text-sm ${trendUp ? 'text-green-500' : 'text-red-500'}`}>
                    <TrendingUp
                        className={`w-4 h-4 mr-1 ${!trendUp ? 'transform rotate-180' : ''}`}
                    />
                    <span>{trend.value}% {trend.label}</span>
                </div>
            )}
        </div>
    );
};

export default StatCard;